import axios from "axios";

export default {
  getCourses() {
    return axios({
      url: "/novo-cursos/api/list",
      method: "GET"
    });
  },
  sendResumePDF(data) {
    return axios({
      url: "/api/curriculo/pdf/",
      method: "POST",
      responseType: "blob",
			data: data
    });
  },
  sendResumeDOC(data) {
    return axios({
      url: "/api/curriculo/doc/",
      method: "POST",
      responseType: "blob",
			data: data
    });
  },
};
